import { jsxs as a, jsx as o } from "react/jsx-runtime";
import { d as v } from "../../vendor-Dd6qj6gJ.js";
import "react";
import { getSpacingClasses as _ } from "../../utils/getSpacingClasses/index.js";
import { Button as n } from "../Button/index.js";
import { Pill as f } from "../Pill/index.js";
import '../../assets/index40.css';const w = "_errorState_1h4nv_1", A = "_header_1h4nv_12", T = "_status_1h4nv_19", S = "_code_1h4nv_25", N = "_copy_1h4nv_32", I = "_title_1h4nv_38", V = "_body_1h4nv_46", x = "_actions_1h4nv_53", t = {
  errorState: w,
  header: A,
  status: T,
  code: S,
  copy: N,
  title: I,
  body: V,
  actions: x
}, q = {
  404: {
    code: "404",
    statusLabel: "Page not found",
    color: "gold",
    title: "We couldn’t find this page",
    body: "The page may have moved, been deleted, or the URL may be incorrect.",
    primaryActionLabel: "Go home",
    secondaryActionLabel: "View docs"
  },
  403: {
    code: "403",
    statusLabel: "Access restricted",
    color: "purple",
    title: "You don’t have access",
    body: "Your account does not have permission to view this resource.",
    primaryActionLabel: "Request access",
    secondaryActionLabel: "Switch account"
  },
  401: {
    code: "401",
    statusLabel: "Session expired",
    color: "purple",
    title: "Your session expired",
    body: "Sign in again to continue. Your current session is no longer active.",
    primaryActionLabel: "Sign in again"
  },
  429: {
    code: "429",
    statusLabel: "Rate limit reached",
    color: "gold",
    title: "Too many requests",
    body: "This account or client sent more requests than the current limit allows. Try again after the retry window.",
    primaryActionLabel: "Try again",
    primaryIcon: "reload-refresh",
    secondaryActionLabel: "View limits"
  },
  500: {
    code: "500",
    statusLabel: "Internal error",
    color: "gold",
    title: "Something went wrong",
    body: "We ran into an unexpected error. Try again, or contact support if the issue continues.",
    primaryActionLabel: "Try again",
    primaryIcon: "reload-refresh",
    secondaryActionLabel: "View status"
  },
  503: {
    code: "503",
    statusLabel: "Service unavailable",
    color: "gold",
    title: "We can’t load this right now",
    body: "Your request reached us, but we couldn’t complete it. This may be temporary.",
    primaryActionLabel: "Try again",
    primaryIcon: "reload-refresh",
    secondaryActionLabel: "View status"
  },
  504: {
    code: "504",
    statusLabel: "Request timed out",
    color: "gold",
    title: "The request timed out",
    body: "The service took too long to respond. This may resolve if you try again.",
    primaryActionLabel: "Try again",
    primaryIcon: "reload-refresh",
    secondaryActionLabel: "View status"
  },
  maintenance: {
    statusLabel: "Scheduled maintenance",
    color: "teal",
    title: "We’re performing maintenance",
    body: "We’re temporarily unavailable while maintenance is in progress.",
    primaryActionLabel: "View status",
    secondaryActionLabel: "View docs"
  }
};
function G({
  variant: c,
  title: l,
  body: d,
  primaryActionLabel: m,
  secondaryActionLabel: u,
  onPrimaryAction: r,
  onSecondaryAction: i,
  m: y,
  mt: h,
  mr: p,
  ml: b,
  mb: g
}) {
  const e = q[c], L = m ?? e.primaryActionLabel, s = u ?? e.secondaryActionLabel;
  return /* @__PURE__ */ a(
    "div",
    {
      className: v(t.errorState, _({ m: y, mb: g, ml: b, mr: p, mt: h })),
      "data-component": "ErrorState",
      children: [
        /* @__PURE__ */ a("div", { className: t.header, children: [
          /* @__PURE__ */ a("div", { className: t.status, children: [
            e.code && /* @__PURE__ */ o("span", { "aria-hidden": "true", className: t.code, children: e.code }),
            /* @__PURE__ */ o(f, { color: e.color, icon: "circle-filled", textValue: e.statusLabel })
          ] }),
          /* @__PURE__ */ a("div", { className: t.copy, children: [
            /* @__PURE__ */ o("h1", { className: t.title, children: l ?? e.title }),
            /* @__PURE__ */ o("p", { className: t.body, children: d ?? e.body })
          ] })
        ] }),
        (r || i) && /* @__PURE__ */ a("div", { className: t.actions, children: [
          r && /* @__PURE__ */ o(n, { startIcon: e.primaryIcon, variant: "primary", onPress: r, children: L }),
          i && s && /* @__PURE__ */ o(n, { variant: "secondary", onPress: i, children: s })
        ] })
      ]
    }
  );
}
export {
  G as ErrorState
};
